import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { setInAppBackPressed } from "../core/actionCreators/configActionCreator";

export const useInAppBackNavigation = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  return () => {
    dispatch(setInAppBackPressed())
    history.goBack()
  }
}

export function useDebounce(value: any, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] 
  );

  return debouncedValue;
}
